import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import { Loader2 } from 'lucide-react';

/**
 * CommandCenter is deprecated. It now redirects to the unified encounter workspace.
 * - Finalized encounters → /note/:id (read-only document)
 * - Active encounters → /visit/:id (unified workspace)
 */
export default function CommandCenter() {
  const { encounterId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    async function redirect() {
      try {
        const res = await api.get(`/encounters/${encounterId}`);
        const enc = res.data.encounter;
        if (enc?.status === 'finalized') {
          navigate(`/note/${encounterId}`, { replace: true });
        } else {
          navigate(`/visit/${encounterId}`, { replace: true });
        }
      } catch {
        setError('Encounter not found');
      }
    }
    redirect();
  }, [encounterId, navigate]);

  if (error) return <div className="p-6 text-center text-muted-foreground">{error}</div>;

  return (
    <div className="flex items-center justify-center h-64">
      <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
    </div>
  );
}
